import Swal from 'sweetalert2';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import SwalAlert from '../SwalAlert';
import swal from 'sweetalert';
import i18next from 'i18next';
import '../styles/swal.alert.button.module.scss';

export const NonDialogSwal = (
  Message,
  Type,
  autoClose = false,
  noTitle = false
) => {
  return new Promise((resolve) => {
    let timer;
    const swalOptions = {
      onClose: () => {
        if (autoClose) clearTimeout(timer);
      },
      title: noTitle
        ? ''
        : i18next.t(
            Type === 'success'
              ? 'Done'
              : Type === 'info'
              ? 'Operation'
              : Type
          ),
      text: ArabicToPersian(Message),
      icon: Type,
    };

    if (Type === 'warning') {
      swalOptions.buttons = {
        confirm: {
          className: 'custom-confirm-button',
        },
      };
    }

    swal(swalOptions).then(resolve);

    if (autoClose) {
      timer = setTimeout(() => swal.close(), 2000);
    }
  });
};

export const DialogSwal = (
  Message,
  Type,
  DialogFunction,
  bodyMessage,
  stateLift,
  autoClose = true,
  noTitle = false
) => {
  return new Promise((resolve) => {
    let timer;
    if (Type === 'fire') {
      Swal.fire({
        title: noTitle
          ? ''
          : i18next.t(
              Type === 'success'
                ? 'Done'
                : Type === 'info'
                ? 'Operation'
                : ''
            ),
        text: `${bodyMessage}`,
        input: 'text',
        showCancelButton: true,
        confirmButtonText: i18next.t('Accept'),
        cancelButtonText: i18next.t('Cancel'),
        onClose: () => {
          if (autoClose) clearTimeout(timer);
        },
      }).then((result) => {
        if (!result.isDismissed) {
          if (result.value.length > 0) {
            DialogFunction(result.value);
            stateLift(result.value);
          } else {
            SwalAlert(
              'error',
              i18next.t('NoDataEntered'),
              false
            );
          }
        }
        resolve();
      });

      if (autoClose) {
        timer = setTimeout(() => Swal.close(), 2000);
      }
    } else {
      swal({
        title: i18next.t('Warning'),
        className: 'swal-form-Els',
        text: Message,
        icon: 'warning',
        buttons: [i18next.t('No'), i18next.t('Yes')],
      }).then((accepted) => {
        if (accepted) {
          DialogFunction();
        }
        resolve();
      });
    }
  });
};
